module.exports = __webpack_public_path__ + "static/media/emoji-icon.e5efc590.svg";